export default {
  "DisplayAgreementInfo.Title": "【同意カード反映】",
  "DisplayAgreementInfo.Text":
    "同意されてから数日かかる場合がありますので予めご了承ください",
}
